export enum TransferMethod {
    Hospital = 1,
    Doctor = 2,
    Clinic = 3,
}
